import React from 'react'
import moment from 'moment'
import { Flag as FlagIcon } from '@material-ui/icons'
import { getFollowupState } from 'apps/leads/utils/followup'
import { Text } from '.'
import { formatFollowUpTime } from './NextActivityRows'

/**
 * The record's set follow-up as the row the Lead list card shows: flag icon + the next open attempt's time (bold) + the
 * follow-up's reason, on one truncating line, red once that time is past. Read from `followup_data` (the issue / lead list
 * endpoints carry it); [] when there is no active follow-up — a completed one, or none, takes no space. `selected` flips to
 * the lighter tints a colored (selected) card needs.
 */
export const getFollowupRows = (item, { selected = false } = {}) => {
  const followup = getFollowupState(item)
  if (!followup.active) return []

  const isOverdue = moment(followup.nextTime).isBefore(moment())
  const color = isOverdue ? (selected ? '#ff5252' : '#d32f2f') : undefined
  const iconColor = selected ? '#fff' : '#9e9e9e'

  return [
    <div key="followup" style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 0 }}>
      <FlagIcon fontSize="small" style={{ color: color || iconColor, flexShrink: 0 }} />
      <Text
        variant="body2"
        component="span"
        noWrap={true}
        textCustomProps={{ minWidth: 0, flex: '1 1 auto', overflow: 'hidden', textOverflow: 'ellipsis', color }}
      >
        <span style={{ fontWeight: 700 }}>{formatFollowUpTime(followup.nextTime)}</span>
        {followup.reason ? ` ${followup.reason}` : ''}
      </Text>
    </div>
  ]
}

/**
 * Scheme component `{ "component": "Followup" }` — a card body field, or a table column's primary / secondary / third.
 * Renders nothing without an active follow-up. `compact` drops the top offset a card row needs (a table cell sits flush).
 */
const FollowupRows = ({ item, selected, compact = false }) => {
  const rows = getFollowupRows(item, { selected })
  if (rows.length === 0) return null
  return <div style={{ minWidth: 0, marginTop: compact ? 0 : 6 }}>{rows}</div>
}

export default FollowupRows
